var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('tramite-table',{attrs:{"no-init":true,"personaId":_vm.personaId,"title":_vm.titulo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }